import React from 'react';
import { useQuery } from '@apollo/client';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { QUERY_FAQ } from '../../graphql/query/faq/faqQuery';
import FaqView from './Faq.view';
import { GetFaqsQuery } from '../../graphql/generated/graphql';
import { getFaqDefFromQuery } from '../../helpers/transformApiResponse/faq';

const Faq = () => {
  const { data, loading, error } = useQuery<GetFaqsQuery>(QUERY_FAQ);
  if (loading) return <LoadingContainer variant="faq" />;
  if (error) return <ErrorContainer text="Erreur FAQ..." />;

  const faqs = data.faqs.data.map(f => getFaqDefFromQuery(f));
  return <FaqView faqs={faqs} />;
};
export default Faq;
